import { Select } from 'components';
import {
  FilterTypes,
  resolveValue,
} from 'components/Table/helpers/tableColumnSort';
import { useMemo } from 'react';

export function SelectColumnFilter({
  column,
  onChange,
  value,
  initData,
  placeholder,
  testid,
  options,
}: any) {
  const { id } = column;
  const generatedOptions = useMemo(() => {
    if (!options) {
      const gOpts: any = new Set();
      initData.forEach((row: any) => {
        gOpts.add(resolveValue(row, id));
      });

      const opts = [...gOpts.values()]
        .map((val: string) =>
          val === FilterTypes.Dash ? FilterTypes.None : val
        )
        .sort();

      return [FilterTypes.All, ...opts].map((item: string, i: number) => ({
        value: item,
        label: item.toString(),
      }));
    } else {
      return options;
    }
  }, [id, initData, options]);

  return (
    <Select
      testid={testid}
      isPortalled
      placeholder={placeholder}
      value={value}
      options={options ?? generatedOptions}
      onChange={onChange}
      style={{ textAlign: 'left' }}
    />
  );
}

export const FilterSelect = (props: any) => (
  <Select {...props} style={{ textAlign: 'left' }} />
);
